import { UserTokens } from '@/types';
import { requestQuery } from '@/services/request';
import { coreMeRoute } from '@/modules/auth/domain/routes/authRoutes';

export const getAuthUser = () =>
  requestQuery<UserTokens>({
    url: coreMeRoute,
  });
